import { useEffect, useState } from "react";

export const getAnimationConfig = (
  isMobile: boolean,
  scrollDirection?: "up" | "down",
) => ({
  duration: isMobile ? 0.15 : 0.2,
  ease: isMobile
    ? "easeOut"
    : scrollDirection === "down"
      ? "backIn"
      : "backOut",
  delay: isMobile ? 0 : scrollDirection === "down" ? 0.2 : 0,
});

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
};
